import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { LoggedUser } from 'src/backend/models/session-users/session-users';
import { BaseApi } from 'src/backend/api/base-api';
import { of, Subscription } from 'rxjs';
import { DynamicDashboardService } from 'src/app/services/dynamic-dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { MessagingService } from 'src/backend/services/messaging.service';
import moment from 'moment';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import * as sdk from 'microsoft-cognitiveservices-speech-sdk';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import * as CryptoJS from "crypto-js";
import { NextBestActionDto } from 'src/backend/models/batch-qc-preparation-model';
import { ChatBotTranslateService } from 'src/backend/services/chat-bot-translate.service';
import { settings } from 'cluster';
import { firstValueFrom } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-ChatBot',
  templateUrl: './ChatBot.component.html',
  styleUrls: ['./ChatBot.component.scss']
})
export class ChatBotComponent implements OnInit {
  isLoader: boolean = false;
  chats = [
    { isBot: true, message: 'Hi, how can I help you?', time: new Date() },
  ];
  userInput = '';
  isChatboxOpen = false;
  userMessage = '';
  chatMessages = [{ text: 'Hello! How can I assist you today?', isBot: true }];
  chatBotImageSrc: any = 'assets/images/robot-icon.png';
  chatBotImageSrc2: any = 'assets/images/chatBot-logo.png';
  humanAvatarSrc: any = 'assets/images/robot-avatar.png';
  shouldShowChatIcon: boolean = false;
  isNextBestAction: boolean = false;
  isCopilot: boolean = false;
  synthesizer: sdk.SpeechSynthesizer | null = null;
  pausedText = "";
  speakTimeout: any = null;
  isCommunicateCollaborate: boolean = false;
  messages: any[] = [];
  chatbotmessages = [
    { type: 'system', content: 'Welcome! How can I assist you today?' },
    { type: 'user', content: 'What is the status of my order?' },
    { type: 'system', content: 'The status of the PO_1234 is completed!' },
  ];
  agentmessages = [
    { type: 'system', content: 'Welcome! How can I Help you?' },
    {
      type: 'user',
      content:
        'Why am I getting an error when trying to fetch data for a purchase order (PO) ?',
    },
    {
      type: 'system',
      content:
        'The error could be due to missing or incorrect relationships between the PurchaseOrder and related tables, such as Product or Vendor. Ensure that foreign key constraints are correctly set up and that your query or model is correctly referencing the columns.',
    },
  ];
  newMessage: string = '';
  activeTab: string = 'messages';
  isSpeaking: boolean = false;
  currentMessageIndex: number = -1;
  highlightWordIndex: number = -1;

  isDragging = false;
  isFullWidth = false;
  draggingWidth = false;
  position = { bottom: 8, right: 5, top: 2, left: 2 };
  dragStartPosition = { x: 0, y: 0 };
  dragThreshold = 5;
  isPaused = false;
  voices: any[] = [];
  selectedAccent: string = '';
  selectedVoice: any;
  userDefaultLanguage: any;
  userProfile: LoggedUser;
  userName: string;
  isButtonPresent = false;
  private observer: MutationObserver;
  private layoutStateSub!: Subscription;
  startX: number = 0;
  startWidth: number = 0;
  plantSession: any;
  userSession: any;
  synth = window.speechSynthesis;
  @Output() isFullWidthChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Output() containerWidth = new EventEmitter<number>();
  @Output() isExceedWidth = new EventEmitter<boolean>();

  @ViewChild('chatbotContainer') chatbotContainer!: ElementRef;
  isResizing: boolean = false;

  contextItems: MenuItem[] = [];

  chatWidth: string = '60%';

  isMuted: boolean = false;
  showControls: boolean = false;
  isChatMsgVisible: boolean = true;
  nextBestAction: NextBestActionDto | null = null;
  private subscriptions: Subscription = new Subscription();
  currentUserName: any;
  isLoadingMessages: boolean = false;
  newGeneratedMessage: boolean = false;
  key = CryptoJS.enc.Utf8.parse(Constants.HASH_KEY);
  iv = CryptoJS.enc.Utf8.parse(Constants.HASH_IV);
  chatBotLanguages: string[] = [];
  filteredAccents: { name: string; value: string }[] = [];
  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
    private baseApi: BaseApi,
    private elRef: ElementRef,
    private dynamicService: DynamicDashboardService,
    private messagingService: MessagingService,
    private employeeService: EmployeeService,
    private toaster: ToastrService,
    private translationService: ChatBotTranslateService
  ) {
    this.messagingService.resetNextBestAction();
  }

  async ngOnInit() {
    this.getChatBotUserLanguages();
    this.voices = await this.translationService.getVoices();
    this.setInitialVoice();

    this.getAllChatBotMessage();
    this.setcontextMenuItems();
    this.onAccentChange();
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.userSession = this.baseApi.getUserSession();
    this.currentUserName = this.userSession.fullName;
    const chatbotConfiguration = JSON.parse(
      localStorage.getItem('user_chatbot_configurations') || '{}'
    );
    this.shouldShowChatIcon =
      chatbotConfiguration.communicationAndCollaborate ||
      chatbotConfiguration.nextBestAction ||
      chatbotConfiguration.copilot;

    this.isNextBestAction = !!chatbotConfiguration.nextBestAction;
    this.isCopilot = !!chatbotConfiguration.copilot;
    this.isCommunicateCollaborate =
      !!chatbotConfiguration.communicationAndCollaborate;

    if (this.activeTab === 'messages' && !this.isNextBestAction) {
      this.switchToFirstAvailableTab();
    }
    this.getProfileInformation();

    await this.getNextBestActions();

    await this.getNextBestReminderAction();
  }

  async getChatBotUserLanguages(): Promise<void> {
    try {
      this.chatBotLanguages = await this.translationService.getChatBotUserLanguages();
      if (this.chatBotLanguages) {
        this.filterAccents();
      }
    } catch (error) {
      console.error("Error fetching languages:", error);
    }
  }



  filterAccents(): void {
    this.filteredAccents = this.accents.filter(accent =>
      this.chatBotLanguages.includes(accent.value)
    );
    this.getDefaultChatbotLanguage();
  }

  getDefaultChatbotLanguage(): void {
    this.translationService.getUserDefaultLanguage().subscribe((res) => {
      this.userDefaultLanguage = res;
      this.selectedAccent = res?.defaultLanguage;
      if (this.selectedAccent) {
        this.updateContextMenu(this.selectedAccent);
      }
    });
  }

  updateContextMenu(selectedAccent: string): void {
    this.filteredAccents.forEach(accent => {
      accent.name = accent.name.replace(" (Default)", "");
    });
    const selected = this.filteredAccents.find(accent => accent.value === selectedAccent);
    if (selected) {
      selected.name += " (Default)";
    }
    this.setcontextMenuItems();
  }

  getNextBestActions(): void {
    this.messagingService.nextBestAction$.subscribe((response: any) => {
      if (response) {
        if (
          response.userCode === this.userSession.userCode &&
          response.plantCode === this.plantSession.plantCode
        ) {
          const formattedMessage = {
            Id: response.id,
            content: response.content || '',
            link: response.link || '',
            type: "Next Best Message",
            isBot: response.isBot ?? false,
            time: moment(response.time).format('hh:mm A'),
            isRead: response.isRead ?? false,
            menuId: response.menuId || '',
            applicationVariant: response.applicationVariant || '',
            route: response.link || '',
          };

          const isDuplicate = this.messages.some(
            (msg) =>
              msg.time === formattedMessage.time &&
              msg.content === formattedMessage.content
          );

          if (!isDuplicate) {
            this.messages.unshift(formattedMessage);
            if (!formattedMessage.isRead) {
              this.newGeneratedMessage = true;
              if (this.isChatboxOpen) {
                this.speakAllMessages();
              }
            } else {
              this.newGeneratedMessage = false;
            }
            if (this.messages.length > 50) {
              this.messages.pop();
            }
          }
        }
      }
    });
  }

  getNextBestReminderAction(): void {
    this.messagingService.nextBestReminderAction$.subscribe((response: any) => {
      if (response) {
        if (
          response.userCode.split(',').includes(this.userSession?.userCode) &&
          response.plantCode === this.plantSession?.plantCode
        ) {
          const formattedMessage = {
            Id: response.id,
            content: response.content || '',
            link: response.link || '',
            type: "Next Best Reminder",
            isBot: response.isBot ?? false,
            time: moment(response.time).format('hh:mm A'),
            isRead: response.isRead ?? false,
            menuId: response.menuId || '',
            applicationVariant: response.applicationVariant || '',
            route: response.link || '',
          };

          const isDuplicate = this.messages.some(
            (msg) =>
              msg.time === formattedMessage.time &&
              msg.content === formattedMessage.content
          );

          if (!isDuplicate) {
            this.messages.unshift(formattedMessage);
            if (!formattedMessage.isRead) {
              this.newGeneratedMessage = true;
              if (this.isChatboxOpen) {
                this.speakAllMessages();
              }
            } else {
              this.newGeneratedMessage = false;
            }
            if (this.messages.length > 50) {
              this.messages.pop();
            }
          }
        }
      }
    });
  }



  setcontextMenuItems(): void {
    this.contextItems = [
      ...this.filteredAccents.map((accent) => ({
        label: accent.name,
        command: () => this.onAccentSelect(accent),
      })),
    ];
  }

  async getAllChatBotMessage() {
    try {
      const data: any = await firstValueFrom(this.employeeService.getAllChatBotNextBestAction());

      data.forEach((item) => {
        if (
          item.plantCode === this.plantSession?.plantCode &&
          item.userId.includes(this.userSession?.userCode)
        ) {
          const formattedMessage = {
            Id: item.id,
            content: item.description || '',
            link: item.title || '',
            type: item.title || '',
            isBot: true,
            time: moment(item.createdOn).format('hh:mm A'),
            isRead: item.isRead,
            menuId: item.menuId || '',
            applicationVariant: item.applicationVariant || '',
            route: item.route || '',
          };
          this.messages.unshift(formattedMessage);
        }
      });

      await this.translateAllMessagesInBatches();

    } catch (error) {
      console.error('Error fetching chatbot messages', error);
    }
  }


  ngAfterViewInit() {
    this.checkButtonPresence();
    const layoutElement = this.elRef.nativeElement.closest('main.main-layout');
    this.observer = new MutationObserver(() => {
      this.checkButtonPresence();
    });

    if (layoutElement) {
      this.observer.observe(layoutElement, { childList: true, subtree: true });
    }
  }

  accents = [
    { name: 'English', value: 'en-US-JasonNeural' },
    { name: 'Arabic', value: 'ar-SA-HamedNeural' },
    { name: 'Hindi', value: 'hi-IN-ArjunNeural' },
    { name: 'Urdu', value: 'ur-PK-AsadNeural' },
  ];

  setInitialVoice() {
    this.selectedVoice =
      this.voices.find((voice) => voice.privShortName === this.selectedAccent) || null;
  }

  toggleFullWidth() {
    this.isFullWidth = !this.isFullWidth;
    this.isFullWidthChange.emit(this.isFullWidth);
  }

  toggleChatbox() {
    this.isChatboxOpen = !this.isChatboxOpen;
  }

  sendMessage() {
    if (this.newMessage.trim()) {
      this.chatbotmessages.push({ content: this.newMessage, type: 'user' });
      this.newMessage = '';
    }
  }

  sendMessagetoAgent() {
    if (this.newMessage.trim()) {
      this.agentmessages.push({ content: this.newMessage, type: 'user' });
      this.newMessage = '';
    }
  }

  async onAccentChange() {
    const voice = this.voices.find((v) => v.privShortName === this.selectedAccent);
    if (voice) {
      this.selectedVoice = voice;
      await this.translateAllMessagesInBatches();

      if (this.synthesizer) {
        this.synthesizer.close();
        this.synthesizer = null;
      }

      this.isSpeaking = false;
      this.isPaused = true;

      if (this.currentMessageIndex !== -1) {
        this.speakAllMessages();
      }
    }
  }

  async translateAllMessagesInBatches(batchSize = 50) {
    const selectedLang = this.selectedAccent.split('-')[0];
    this.isLoadingMessages = true;

    const batches = [];
    for (let i = 0; i < this.messages.length; i += batchSize) {
      batches.push(this.messages.slice(i, i + batchSize));
    }

    for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
      const batch = batches[batchIndex];

      try {
        const response = await firstValueFrom(
          this.translationService.translateMessages(batch, selectedLang).pipe(
            catchError((err) => {
              console.error('Batch translation error', err);
              return of([]);
            })
          )
        );

        response.forEach((translatedMsg: any, index: number) => {
          const originalIndex = batchIndex * batchSize + index;
          if (this.messages[originalIndex]) {
            this.messages[originalIndex].content = translatedMsg.translations[0].text;
          }
        });

      } catch (err) {
        console.error('Translation batch error:', err);
      }
    }

    this.isLoadingMessages = false;
  }

  onAccentSelect(accent: { name: string; value: string }) {
    this.updateAccent(accent.value);
  }

  updateAccent(language: string): void {
    const data = this.userDefaultLanguage
    const key = {
      id: data.id,
      userCode: data.userCode,
      defaultLanguage: language,
    };
    this.translationService.updateUserDefaultLanguage(key).subscribe(
      (data: any) => {
        console.log(data, 'data');
        this.selectedAccent = language;
        if (this.selectedAccent) {
          this.updateContextMenu(this.selectedAccent);
        }
        this.onAccentChange();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  otherAction() {
    console.log('Other action triggered');
  }

  getVoiceByAccent(accent: string): SpeechSynthesisVoice | null {
    const selectedVoice = this.voices.find((voice) =>
      voice.lang.includes(accent)
    );

    return selectedVoice || this.voices[0];
  }


  translateAllMessages() {
    const selectedLang = this.selectedAccent.split('-')[0];
    this.isLoadingMessages = true;
    this.translationService.translateMessages(this.messages, selectedLang).subscribe(
      (response) => {
        response.forEach((translatedMsg: any, index: number) => {
          this.messages[index].content = translatedMsg.translations[0].text;
        });
        this.isLoadingMessages = false;
      },
      (error) => {
        this.isLoadingMessages = false;
      }
    );
  }

  async openChatbot() {
    this.isLoadingMessages = true;
    try {
      const response = await firstValueFrom(
        this.translationService.translateMessages(this.messages, this.selectedAccent.split('-')[0])
      );
      response.forEach((translatedMsg: any, index: number) => {
        this.messages[index].content = translatedMsg.translations[0].text;
      });
    } catch (error) {
    }
    this.isLoadingMessages = false;

    const unreadMessages = this.messages.filter(msg => !msg.isRead);
    if (unreadMessages.length > 0) {
      if (this.isPaused) {
        this.resumeSpeech();
        this.isPaused = false;
      } else {
        this.speakAllMessages();
      }
    } else {
      const timeBasedGreeting = this.getTimeBasedGreeting();
      this.speakGreetingAndMessages(timeBasedGreeting);
    }
    setTimeout(() => {
      this.isChatboxOpen = true;
    }, 500);
  }

  getTimeBasedGreeting(): string {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
      return 'Good morning! How can I assist you today?';
    } else if (currentHour >= 12 && currentHour < 17) {
      return 'Good afternoon! How can I assist you today?';
    } else if (currentHour >= 17 && currentHour < 21) {
      return 'Good evening! How can I assist you today?';
    } else {
      return 'Good night! How can I assist you today?';
    }
  }

  speakGreetingAndMessages(greeting: string) {
    if (this.messages.every((msg) => msg.isRead)) {
      this.translateText(greeting, this.selectedAccent, (response: any) => {
        const translatedText = response[0].translations[0].text;
        const translatedlang = response[0].translations[0].to;
        this.speakTranslatedText(translatedText, translatedlang);
      });

    } else {
      this.speakAllMessages();
    }
  }


  translateText(textToTranslate: string, targetLanguage: string, callback: (response: any) => void) {
    const firstPart = targetLanguage.split('-')[0];
    this.translationService.translateText(textToTranslate, firstPart).subscribe(
      (response) => {
        callback(response);
      },
      (error) => {
      }
    );
  }



  async speakTranslatedText(translatedText: string, language: string): Promise<number> {
    try {
      if (!this.selectedAccent) return 0;

      const speechConfig = sdk.SpeechConfig.fromSubscription(
        this.translationService.speechrapiKey,
        this.translationService.region
      );
      speechConfig.speechSynthesisVoiceName = this.selectedAccent;

      const audioConfig = this.isMuted
        ? sdk.AudioConfig.fromSpeakerOutput(null)
        : sdk.AudioConfig.fromDefaultSpeakerOutput();
      this.synthesizer = new sdk.SpeechSynthesizer(speechConfig, audioConfig);
      this.isSpeaking = true;

      const audioData: Uint8Array = await new Promise<Uint8Array>((resolve, reject) => {
        this.synthesizer.speakTextAsync(
          translatedText,
          (result) => {
            if (result.reason === sdk.ResultReason.SynthesizingAudioCompleted) {
              resolve(new Uint8Array(result.audioData));
            } else {
              reject(result.errorDetails);
            }
            this.synthesizer.close();
          },
          (error) => {
            this.synthesizer.close();
            reject(error);
          }
        );
      });

      const audioContext = new AudioContext();
      const audioBuffer = await audioContext.decodeAudioData(audioData.buffer.slice(0));
      const durationMs = audioBuffer.duration * 1000;

      return durationMs;
    } catch (error) {
      this.isSpeaking = false;
      console.error('Speech synthesis error:', error);
      return this.estimateSpeechDuration(translatedText, language);
    }
  }






  sanitizeHTML(content: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }

  onClickMessage(message: any) {
    if (message.applicationVariant === Constants.CORE_APP_NAME || message.applicationVariant === Constants.UI_FORM_BUILDER_APP_NAME || message.applicationVariant === Constants.UTILITY_APP_NAME) {
      const appURL = this.baseApi.getAppURL(message.applicationVariant);
      const plantCode: string = this.baseApi.getPlantCodeFromStorage();
      const groupCode: string = this.baseApi.getGroupCodeFromStorage();
      const queryParams = {
        email: this.userProfile?.userName,
        plantCode,
        groupCode,
        menuId: message?.menuId,
        languageName: localStorage.getItem('Language_Name')
      };
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(queryParams),
        this.key,
        { iv: this.iv }
      );
      this.openUrlWithParameters(appURL, { encrypted: encrypted.toString() })
    }
    else {
      const routeUrl = this.router.serializeUrl(this.router.createUrlTree([message.route]));
      const baseUrl = window.location.origin;
      const fullUrl = `${baseUrl}${routeUrl}`;
      window.open(fullUrl, '_blank');
    }
  }

  openUrlWithParameters(
    url: string,
    parameters: { [key: string]: string }
  ): void {
    const queryString = Object.keys(parameters)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(parameters[key])}`
      )
      .join('&');
    const urlWithParameters = `${url}?${queryString}`;
    window.open(urlWithParameters, '_blank');
  }

  estimateSpeechDuration(translatedText: string, language: string): number {
    let wordsPerSecond = 2.5;

    switch (language.toLowerCase()) {
      case 'ur':
        wordsPerSecond = 2.3;
        break;
      case 'hi':
        wordsPerSecond = 1.9;
        break;
      case 'ar':
        wordsPerSecond = 1.5;
        break;
    }
    const words = translatedText.trim().split(/\s+/).length;
    return (words / wordsPerSecond) * 1000;
  }


  async speakAllMessages() {
    this.isSpeaking = true;
    if (!this.messages.length) return;
    if (this.synthesizer) {
      this.synthesizer.close();
      this.synthesizer = null;
    }

    if (this.currentMessageIndex === -1 || this.currentMessageIndex >= this.messages.length) {
      this.currentMessageIndex = 0;
    }

    const speakMessage = async (index: number) => {
      if (this.isPaused || index >= this.messages.length) {
        this.isSpeaking = false;
        this.currentMessageIndex = -1;
        return;
      }

      const currentMessage = this.messages[index];

      if (currentMessage.isRead) {
        speakMessage(index + 1);
        return;
      }

      try {
        const translatedText = await new Promise<string>((resolve, reject) => {
          this.translateText(currentMessage.content, this.selectedAccent, (response: any) => {
            if (response?.[0]?.translations) {
              resolve(response[0].translations[0].text);
            } else {
              reject("Translation failed");
            }
          });
        });

        currentMessage.content = translatedText;
        this.currentMessageIndex = index;

        const durationMs = await this.speakTranslatedText(translatedText, this.selectedAccent);

        this.messages[index].isRead = true;
        const key = { Id: currentMessage.Id };
        this.employeeService.NextBestActionRead(key).subscribe(
          (data: any) => console.log('Message marked as read.', data),
          (error: any) => this.toaster.error('Error', error.message)
        );

        if (!this.isPaused) {
          setTimeout(() => {
            speakMessage(index + 1);
          }, durationMs);
        }
      } catch (error) {
        console.error('Error speaking message:', error);
        speakMessage(index + 1);
      }
    };

    speakMessage(this.currentMessageIndex);
  }



  async togglePlayPause() {
    if (this.isSpeaking && !this.isPaused) {
      this.pauseSpeech();
    } else {
      this.resumeSpeech();
    }
  }

  async resumeSpeech() {
    if (!this.isPaused) return;

    this.isPaused = false;
    this.isSpeaking = true;

    if (this.currentMessageIndex < this.messages.length) {
      this.speakAllMessages();
    }
  }

  async speakText(text: string) {
    const speechConfig = sdk.SpeechConfig.fromSubscription(
      this.translationService.speechrapiKey,
      this.translationService.region
    );

    speechConfig.speechSynthesisVoiceName = this.selectedAccent;
    const audioConfig = sdk.AudioConfig.fromDefaultSpeakerOutput();
    this.synthesizer = new sdk.SpeechSynthesizer(speechConfig, audioConfig);

    this.synthesizer.speakTextAsync(
      text,
      (result) => {
        if (result.reason === sdk.ResultReason.SynthesizingAudioCompleted) {
          this.isSpeaking = false;
          this.isPaused = false;
          this.currentMessageIndex = -1;
          this.synthesizer?.close();
        }
      },
      (error) => {
        this.synthesizer?.close();
      }
    );
  }

  pauseSpeech() {
    if (this.synthesizer) {
      this.synthesizer.close();
      this.synthesizer = null;
    }
    this.isPaused = true;
    this.isSpeaking = false;
    clearTimeout(this.speakTimeout);
  }

  toggleSpeech() {
    if (this.isSpeaking) {
      this.stopSpeaking();
    } else {
      this.speakAllMessages();
    }
  }

  toggleMute() {
    this.isMuted = !this.isMuted;
  }



  get unreadMessagesCount(): number {
    return this.messages.filter((msg) => !msg.isRead).length;
  }

  stopSpeaking() {
    if (speechSynthesis.speaking || speechSynthesis.pending) {
      speechSynthesis.cancel();
      const silence = new SpeechSynthesisUtterance('');
      silence.volume = 0;

      speechSynthesis.speak(silence);
      speechSynthesis.cancel();

      this.isSpeaking = false;
      this.isPaused = false;
      this.currentMessageIndex = -1;
      this.highlightWordIndex = -1;
    }
  }

  getButtonColor() {
    if (this.isPaused) {
      return 'gray';
    }
    return this.isSpeaking
      ? 'green'
      : 'linear-gradient(to right, #60EFFF, #0061FF)';
  }

  switchTab(tab: string) {
    if (
      this.activeTab != 'messages' ||
      !this.isNextBestAction ||
      this.isCopilot
    ) {

      speechSynthesis.pause();
      this.isPaused = true;
    }

    this.activeTab = tab;
  }

  private switchToFirstAvailableTab(): void {
    if (this.isNextBestAction) {
      this.activeTab = 'messages';
    } else if (this.isCopilot) {
      this.activeTab = 'copilot';
    } else if (this.isCommunicateCollaborate) {
      this.activeTab = 'help';
    } else {
      this.activeTab = '';
    }
  }

  toggleChatbot() {
    if (this.isChatboxOpen) {
      this.closeChatbot();
    } else {
      this.openChatbot();
    }
  }

  closeChatbot() {
    this.isChatboxOpen = false;
    this.userInput = '';
    this.chats = null;
    this.chats = [
      { isBot: true, message: 'Hi, how can I help you?', time: new Date() },
    ];
    if (this.isSpeaking && !this.isPaused) {
      speechSynthesis.pause();
      this.isPaused = true;
    }
  }

  startResize(event: MouseEvent): void {
    this.isResizing = true;
    this.startX = event.clientX;
    this.startWidth = (event.target as HTMLElement).parentElement!.offsetWidth;

    document.body.style.userSelect = 'none';

    document.addEventListener('mousemove', this.resize);
    document.addEventListener('mouseup', this.stopResize);
  }

  resize = (event: MouseEvent) => {
    if (!this.isResizing) return;

    requestAnimationFrame(() => {
      const dx = event.clientX - this.startX;
      const newWidth = ((this.startWidth - dx) / window.innerWidth) * 100;
      const minWidth = 33;
      const maxWidth = 99;

      if (newWidth >= minWidth && newWidth <= maxWidth) {
        const chatbotContainer = document.querySelector(
          '.chatbot-container'
        ) as HTMLElement;

        chatbotContainer.style.width = `${newWidth}vw`;

        const isExceedingWidth = newWidth >= 50;

        this.isFullWidth = newWidth >= 100;
        this.draggingWidth = newWidth >= 65;
        this.isExceedWidth.emit(this.draggingWidth);
      }
    });
  };

  stopResize = () => {
    this.isResizing = false;

    document.body.style.userSelect = '';

    document.removeEventListener('mousemove', this.resize);
    document.removeEventListener('mouseup', this.stopResize);
  };

  calculateNewWidth(e: MouseEvent): number {
    const dx = e.clientX - this.startX;
    const newWidth = this.startWidth - dx;
    return Math.max(20, newWidth);
  }

  checkButtonPresence() {
    const button = document.querySelector('.menu-button');
    const wasPresent = this.isButtonPresent;
    this.isButtonPresent = !!button;

    if (wasPresent !== this.isButtonPresent) {
    }
  }

  getProfileInformation() {
    this.userProfile = this.baseApi.getUserSession();
    this.userName = this.userProfile?.userName;
  }


  sendCommunicationMessage() {
    if (!this.userInput.trim()) {
      this.toaster.info(
        'Your query has an empty field. Please provide the required information and try again.'
      );
      return;
    }
    this.chats.push({
      isBot: false,
      message: this.userInput,
      time: new Date(),
    });
    const data = {
      query: this.userInput,
    };
    this.isLoader = true;
    this.dynamicService.getResponseVectara(data).subscribe((data) => {
      this.chats.push({
        isBot: true,
        message: data.responseSet[0].summary[0].text,
        time: new Date(),
      });
      this.userInput = '';
      this.isLoader = false;
    });
  }
  clearCommunicationMessage() {
    this.chats = [];
    this.chats = [
      { isBot: true, message: 'Hi, how can I help you?', time: new Date() },
    ];
  }

  hideChatMessage(): void {
    this.isChatMsgVisible = false;
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.subscriptions.unsubscribe();
  }

}
